import * as React from "react";
import {Component} from "react";

interface InputComponentProps {
    type: string;
    label: string;
    name: string;
    units: string;
    classNames: string;
    inputElementId?: string;
    disabled: boolean;
    readOnly?: boolean;
    value: number | string;
    forwardedRef?: React.RefObject<HTMLInputElement>;
    placeholder?: string;
    onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
    onBlur?(event: React.ChangeEvent<HTMLInputElement>): void;
    onClick?(event: React.MouseEvent<HTMLElement>): void;
}

class BaseInputComponent extends Component<InputComponentProps> {
    render() {
        const {type, label,name, units, classNames, inputElementId, disabled, readOnly,
            onChange, onClick, value, forwardedRef, placeholder, onBlur} = this.props;
        return(
            <label onClick={onClick}>
                {label}
                <input
                    type={type}
                    name={name}
                    className={classNames}
                    id={inputElementId}
                    disabled={disabled}
                    readOnly={readOnly}
                    onChange={onChange}
                    value={value}
                    ref={forwardedRef}
                    placeholder={placeholder}
                    onBlur={onBlur}
                />
                <span className="units">{units}</span>
            </label>
        );
    }
}

// Syntax for forwarding refs in class components is a little convoluted. For more detail see:
// https://www.reddit.com/r/reactjs/comments/91ua32/reactforwardref_in_a_class_based_component/
function ForwardRef(props, ref) {
    return <BaseInputComponent {...props} forwardedRef={ref} />;
}

const InputComponent = React.forwardRef(ForwardRef);

export {InputComponent as default, InputComponent};



// WEBPACK FOOTER //
// ./src/shared/ui/common/InputComponent.tsx